import {storeInstance} from '@aofl/store/dist/legacy';
import {deepAssign} from '@aofl/object-utils';
import {sdoNs} from '../constants-enumerate';
import {SendWidgetModalEvent} from '@epg/epg-components';

const sdo = {
  namespace: sdoNs.SIMPLE_MODAL,
  mutations: {

    /**
     *
     * @param {Object} payload
     * @return {Object}
     */
    init(payload) {
      return Object.assign({
        modals: {
          // id: {show: Boolean, data: {}} // visible state
        }
      }, payload);
    },

    /**
     *
     * @param {Object} substate
     * @param {String} id
     * @return {Object}
     */
    addModal(substate, id) {
      return deepAssign(substate, 'modals', {
        [id]: {
          show: false,
          data: {}
        }
      });
    },

    /**
     *
     * @param {Object} substate
     * @return {Object}
     */
    hideModals(substate) {
      const modals = {};

      if (substate.$activeModalId !== '') {
        SendWidgetModalEvent.enqueue(substate.$activeModalId, 'widget.close');
      }

      for (const key in substate.modals) {
        if (!substate.modals.hasOwnProperty(key)) continue;

        if (substate.modals[key].show) {
          modals[key] = {
            show: false,
            data: {}
          };
        }
      }

      return Object.assign({}, substate, {modals});
    },

    /**
     *
     * @param {Object} substate
     * @param {String} id
     * @return {Object}
     */
    showModal(substate, {id, data}) {
      const _substate = sdo.mutations.hideModals(substate);
      SendWidgetModalEvent.enqueue(id, 'widget.open');

      return deepAssign(_substate, 'modals', {
        [id]: {
          show: true,
          data
        }
      });
    }
  },
  decorators: [
    (_nextState) => {
      const state = storeInstance.getState();
      let nextState = _nextState;

      if (typeof nextState[sdoNs.SIMPLE_MODAL].$activeModalId === 'undefined' ||
      nextState[sdoNs.SIMPLE_MODAL].modals !== state[sdoNs.SIMPLE_MODAL].modals) {
        let $activeModalId = '';
        for (const key in nextState[sdoNs.SIMPLE_MODAL].modals) {
          if (!nextState[sdoNs.SIMPLE_MODAL].modals.hasOwnProperty(key)) continue;

          if (nextState[sdoNs.SIMPLE_MODAL].modals[key].show === true) {
            $activeModalId = key;
            break;
          }
        }

        nextState = deepAssign(nextState, sdoNs.SIMPLE_MODAL, {
          $activeModalId
        });
      }

      return nextState;
    }
  ]
};

storeInstance.addState(sdo);
